import React from 'react';

import { Box, Skeleton } from '@mui/material';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';

const SkeletonComponent: React.FC = () => {
  const theme = useThemeContext();

  return (
    <Box
      sx={{
        width: '100%',
        margin: '0',
        padding: '1rem',
        background: theme.background.secondary,
        borderRadius: '8px',
        gap: '0.5rem',
      }}
    >
      <Skeleton animation="wave" sx={{ width: '85%', height: '48px' }} />
      <Skeleton animation="wave" sx={{ width: '70%' }} />
      <Skeleton animation="wave" sx={{ width: '40%' }} />
      <Skeleton animation="wave" sx={{ width: '60%' }} />
      <Skeleton animation="wave" sx={{ width: '40%' }} />
      <Skeleton animation="wave" sx={{ width: '60%' }} />
      <Skeleton animation={false} sx={{ width: '75%' }} />
    </Box>
  );
};

export default SkeletonComponent;
